import React, { useContext, useMemo } from 'react';

import RecordsGrid from 'components/Grid/RecordsGrid';
import GridProvider from 'contextProviders/GridProvider';
import OrderDetailsContext from 'contexts/OrderDetailsContext';

const OrderTabContainer = ({ tab }: { tab: string }) => {
  const { orderNumber } = useContext(OrderDetailsContext);
  // Kept between renders: a new filter would load the rows again
  const metricFiltering = useMemo(
    (): FilterInput => ({
      keywords: [{ field: 'orderNo', values: [orderNumber] }],
      ranges: [],
      booleanFilters: [],
      wildcardFilters: [],
    }),
    [orderNumber],
  );

  return (
    <GridProvider
      dataType={tab.toLowerCase()}
      metricFiltering={metricFiltering}
    >
      <RecordsGrid
        surface="orderTab"
        // AG sizes the columns to their cells (not headers) as rows load
        sizing="fitContent"
        skipHeaderWhenSizing
        isResizable
        layoutOnFirstRender={false}
        layoutOnColumnChange={false}
        layoutOnModelUpdated={true}
        hasBorders
        hasDarkHeader
      />
    </GridProvider>
  );
};

export default OrderTabContainer;
